// Lenis intercepts scrolling, so anchor links and scrollIntoView fight its
// animation. App registers its instance here and the contact CTAs scroll
// through it, falling back to native smooth scroll if it isn't ready yet.
let lenis = null;

export const registerLenis = (instance) => {
  lenis = instance;
};

export const CONTACT_ANCHOR = "contact";

export const scrollToContact = () => {
  const target = document.getElementById(CONTACT_ANCHOR);
  if (!target) return;
  if (lenis) lenis.scrollTo(target, { duration: 1.2 });
  else target.scrollIntoView({ behavior: "smooth", block: "start" });
};
